export default async function ({ store, route, redirect }) {
  if (route.name === 'yir_2019_share') {
    return;
  }
  if (route.name.split('_')[0] === 'referral') {
    redirect('/referral-mitra/off');
    return;
  }
  if (route.name.split('_')[0] === 'yir') {
    redirect('/syukuran/off');
  }
}
